// export const API_URL = 'https://monkbot.azurewebsites.net';
// export const API_URL = 'http://localhost:8000';
export const API_URL = 'https://monk-bot.azurewebsites.net';
